document.querySelectorAll('div.radio').forEach(e => {
    let name = e.dataset.name;
    let value = +e.dataset.value;
    let input = document.createElement('input');
    input.type = 'number';
    input.name = name;
    input.value = value;
    input.defaultValue = value;
    input.addClass('trigger');

    e.querySelectorAll('div.option').forEach(o => {
        o.innerHTML = '<div><span></span></div><span class="text">' + o.innerHTML + '</span>';
        if(+o.dataset.id === value) o.addClass('active');

        o.addEventListener('click', () => {
            e.querySelectorAll('div.option').forEach(a => a.removeClass('active'));
            o.addClass('active');
            input.value = +o.dataset.id;
        })
    })

    e.appendChild(input);

    input.addEventListener('change', () => {
       const value = input.value;
        e.querySelectorAll('div.option').forEach((o) =>{
            o.removeClass('active');
        })
        e.querySelector(`div.option[data-id="${value}"]`).addClass('active');
    })
})